import { Controller, Control } from 'react-hook-form';
import { useDropzone } from 'react-dropzone';
import { Row } from '@/ui/primatives';

import * as Styled from './styled';

type TFileDropzoneProps = {
  maxFiles?: number;
  onDrop: (files: File[]) => void;
  error: any;
  note?: React.ReactNode;
};

const FileDropzone: React.FC<TFileDropzoneProps> = ({ maxFiles = 0, onDrop, error, note }) => {
  const multiple = maxFiles !== 1;
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, maxFiles, multiple });

  const heading = multiple
    ? 'Drag files here to add them to your repository'
    : 'Drag a file here to add it to your repository';
  const hint = multiple ? 'select files' : 'select a file';

  return (
    <div {...getRootProps()}>
      {/* <pre>{JSON.stringify(error, null, 2)}</pre> */}
      <input {...getInputProps()} />
      <Styled.Dropzone $error={!!error}>
        <Styled.DropzoneContent>
          <h5>{heading}</h5>
          {note}
          <div>
            or <a className="link-underline">click here</a> to {hint}
          </div>
          {!!error && <div className="error">{error.message}</div>}
        </Styled.DropzoneContent>
      </Styled.Dropzone>
    </div>
  );
};

type TFileDropZoneInputProps = TFileDropzoneProps & {
  control: Control<any>;
};

const FileDropZoneInput: React.FC<TFileDropZoneInputProps> = ({ control, maxFiles = 0, onDrop, error, note }) => {
  return (
    <Controller
      control={control}
      name="file"
      render={({ field: { onChange, onBlur }, fieldState }) => (
        <FileDropzone maxFiles={maxFiles} onDrop={onDrop} error={error} note={note} />
      )}
    />
  );
};

export default FileDropZoneInput;
